export default __webpack_public_path__ + "static/media/timerProcess.e525f845.svg";